/**
 * @file JobWizardSidebarSlot.tsx
 *
 * @fileoverview This component can be used to render custom things in the job wizard sidebar. The slot is placed
 * below JobCart and JobWizardCurrentOrg components.
 */

export const JobWizardSidebarSlot = () => {
  return null;
};

export default JobWizardSidebarSlot;
